var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":"","id":"chat"}},[_c('messages-list'),_c('send-message')],1)}
var staticRenderFns = []

export { render, staticRenderFns }